import { fetchConfig } from './auth/authProvider';

(async () => {
    await fetchConfig();
    require('./indexApp.js');
}
)();

